import { render, staticRenderFns } from "./FallBack.vue?vue&type=template&id=2ec1c7fe&scoped=true&"
import script from "./FallBack.vue?vue&type=script&lang=ts&"
export * from "./FallBack.vue?vue&type=script&lang=ts&"
import style0 from "./FallBack.vue?vue&type=style&index=0&id=2ec1c7fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec1c7fe",
  null
  
)

export default component.exports